document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector("[data-mobile-announcement]");
  const closeBtn = document.querySelector("[data-mobile-announcement-close]");
  if (!bar || !closeBtn) return;

  const key = "mobile_announcement_closed";
  const isClosed = sessionStorage.getItem(key) === "1";
  if (isClosed) bar.classList.add("is-hidden");

  closeBtn.addEventListener("click", () => {
    bar.classList.add("is-hidden");
    sessionStorage.setItem(key, "1");
  });
});



// ADD TO CART - CART PRODUCT COUNT 

(function () {
  const SELECTOR = ".cart-count-bubble, .mobile-cart__count";

  function setCount(count) {
    const nodes = document.querySelectorAll(SELECTOR);
    console.log("[CartBubble] setCount:", count, "nodes:", nodes.length);

    nodes.forEach((el) => {
      el.textContent = String(count);
      el.style.display = count > 0 ? "" : "none";
      el.setAttribute("aria-label", `${count} items in cart`);
    });
  }

  async function refreshCount() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) {
        console.log("[CartBubble] /cart.js failed:", res.status);
        return;
      }
      const cart = await res.json();
      setCount(cart.item_count || 0);
    } catch (e) {
      console.log("[CartBubble] refreshCount error:", e);
    }
  }

  document.addEventListener("DOMContentLoaded", refreshCount);
  document.addEventListener("cart:refresh", refreshCount);

  const _fetch = window.fetch;
  if (_fetch) {
    window.fetch = async function (...args) {
      const res = await _fetch.apply(this, args);

      try {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
        if (url && url.includes("/cart/")) {
          console.log("[CartBubble] fetch cart request:", url);
          setTimeout(refreshCount, 200);
        }
      } catch (_) {}

      return res;
    };
  }
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__cartUrl = url;
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      try {
        if (this.__cartUrl && String(this.__cartUrl).includes("/cart/")) {
          console.log("[CartBubble] XHR cart request:", this.__cartUrl);
          setTimeout(refreshCount, 200);
        }
      } catch (_) {}
    });

    return _send.apply(this, args);
  };
  function bindJquery() {
    if (!window.jQuery) return;
    console.log("[CartBubble] jQuery detected: binding ajaxComplete");

    window.jQuery(document).ajaxComplete(function (_evt, _xhr, settings) {
      try {
        if (settings?.url && String(settings.url).includes("/cart/")) {
          console.log("[CartBubble] jQuery cart request:", settings.url);
          setTimeout(refreshCount, 200);
        }
      } catch (_) {}
    });
  }

  bindJquery();
  setTimeout(bindJquery, 1000);
})();





// STICKY HEADER
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[data-header]");
  const stickyBar = document.querySelector("[data-sticky-bar]");
  if (!header || !stickyBar) return;

  const setStickyHeightVar = () => {
    const h = stickyBar.offsetHeight || 0;
    document.documentElement.style.setProperty("--sticky-bar-height", `${h}px`);
    console.log("[StickyHeader] sticky bar height:", h);
  };

  const onScroll = () => {
    const topEl = header.querySelector(".header-top");
    const topHeight = topEl ? topEl.offsetHeight : 0;
    document.body.classList.toggle("is-sticky", window.scrollY > topHeight);
  };

  setStickyHeightVar();
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => { setStickyHeightVar(); onScroll(); });
});
